import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
} from "@ui/alert-dialog";
import { requestDeleteAccount, signOut } from "@lib/stores";
import TranslatedText from "@components/items/display/TranslatedText";

const RemoveAccountDialog = ({
  openDialog,
  setOpenDialog,
}: {
  openDialog: boolean;
  setOpenDialog: (state: boolean) => void;
}) => {
  const onOpenChange = () => {
    setOpenDialog(false);
  };
  return (
    <AlertDialog
      open={openDialog}
      onOpenChange={(open) => {
        onOpenChange();
      }}
    >
      <AlertDialogContent className="border-none bg-white dark:bg-[#37383F]">
        <AlertDialogHeader className="flex items-center justify-center gap-3 pb-5 pt-2 text-sm ltr:text-left rtl:text-right">
          <TranslatedText
            text={`settings.dialogs.${"you are about to delete your account"}`}
            className="dark:text-white"
          />
        </AlertDialogHeader>
        <AlertDialogFooter className="mx-auto gap-x-4">
          <AlertDialogAction
            className="bg-[#D9D9D9] hover:bg-[#D9D9D9] hover:opacity-85"
            onClick={() => {
              requestDeleteAccount(() => {
                signOut();
              });
            }}
          >
            <TranslatedText
              text={`settings.dialogs.${"confirm deletion"}`}
              className="text-[16px] font-normal !text-[#FF5153]"
            />
          </AlertDialogAction>
          <AlertDialogCancel className="dark:border-none dark:hover:bg-transparent">
            <TranslatedText
              text={`settings.dialogs.${"cancel the deletion request"}`}
              className="text-[16px] font-normal !text-[#FF5153]"
            />
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default RemoveAccountDialog;
